@if (items().length > 0) {
  <div
    class="rounded-t-radius-secondary border border-b-0 border-action-secondary-30 bg-action-secondary-30 px-3 pt-2 pb-5 text-xs text-foreground-primary-100"
  >
    <div class="flex flex-wrap gap-1.5">
      @for (item of items(); track item.key) {
        <span class="inline-flex items-center gap-1 rounded-full bg-background-container-primary px-2 py-1">
          <span class="text-foreground-primary-60">{{ item.label }}:</span>
          <span class="font-medium">{{ item.value }}</span>
          @if (removable()) {
            <button
              type="button"
              class="ml-0.5 flex size-4 shrink-0 items-center justify-center rounded-full text-foreground-primary-60 leading-none transition-colors hover:bg-action-secondary-30 hover:text-foreground-primary-100"
              [attr.aria-label]="'ai-assistant.remove-context' | translate"
              [title]="'ai-assistant.remove-context' | translate"
              (click)="removed.emit(item.key)"
            >
              <svg-icon key="close-v-2-24" size="10"></svg-icon>
            </button>
          }
        </span>
      }
    </div>
  </div>
}
